import React, { Component } from "react";
import { connect } from "react-redux";
import "./content.scss";
import dashboardIcon from "../../../assets/svg/dashboardBlue.svg";
import { Link } from "react-router-dom";
import dashboardImg from "../../../assets/dashboard.png";
import { configure_progress, gettingStartedProgress } from "../../../actions/globalAction";
import { Dimmer, Loader } from "semantic-ui-react";
import { setActiveModule } from "../../../actions/sideBarActions";
class ExploreDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {}

    configureProgress = () => {
        localStorage.setItem("activeModule", "Listening");
        this.props.configure_progress("explore_dashboards", this.props.total_fields);
        this.props.setModule("Listening");
    };

    render() {
        return (
            <>
                <div className="gs_content">
                    <div className="left_content">
                        <div className="gs_header">
                            <img src={dashboardIcon} color="#268af6" className="icon_content" />
                            <span className="content_title">Dashboards</span>
                        </div>
                        <div className="text_content">
                            <p>{`This is where you see Analytics and raw conversations for all the data you are tracking. `}</p>
                            <p>{`We have pre-created a few standard dashboards for you. Please explore them.  You can also create your own dashboards by cloning an existing dashboard or from scratch.  You can share your dashboards with team members or even with the public.`}</p>
                            <p>{`You can change your filters to refine the data and charts you are viewing.  You can drill down from the charts in the dashboard to view additional details about the data points.`}</p>
                        </div>
                        <Link to="/dashboard/all">
                            <button className="gs_link" onClick={() => this.configureProgress()}>
                                Explore Dashboard
                            </button>
                        </Link>
                    </div>
                    <div className="right_content">
                        <div id="gs_loader">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                        <iframe
                            width="320px"
                            height="200px"
                            src="https://www.youtube.com/embed/QWB-B2HsjXQ?modestbranding=1"
                            title=""
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                            className="content_video"></iframe>
                        {/* <img className="content-img" src={dashboardImg} width="350px" height="200px" /> */}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        configure_progress: (field, total) => dispatch(configure_progress(field, total)),
        setModule: (data) => dispatch(setActiveModule(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExploreDashboard);
